




























import {Vue, Component, Watch, Prop} from 'vue-property-decorator';

@Component({
    components: {}
})
export default class App extends Vue {
    @Prop({})
    poiData: any;

    @Watch('poiData')
    onUserData(poiData: any, oldVal: any) {
        this.draw();
    }

    svg3DTagCloud:any;

    draw () {
        if (!this.poiData.RightData || !this.poiData.RightData['门店标签(通过评价体系挖掘出的标签)']) {
            return void 0;
        }
        let drawData = this.dealDrawData(this.poiData.RightData['门店标签(通过评价体系挖掘出的标签)']);
        this.drawWordCloud({
            dom: this.$refs.tagsMountInner,
            data: drawData,
        });
    }

    dealDrawData (data=[]) {
        let getFontSize = (index) => {
            // if (index < 5) {return '16px';}
            // if (index < 10) {return '13px';}
            // if (index < 15) {return '11px';}
            // if (index < 20) {return '8px';}
            // return '12px';

            if (window['_screenType'] === '2160') {
                if (index < 5) {return '0.24rem';}
                if (index < 10) {return '0.20rem';}
                if (index < 15) {return '0.18rem';}
                if (index < 20) {return '0.16rem';}
                return '0.24rem';
            } else {
                if (index < 5) {return '0.22rem';}
                if (index < 10) {return '0.20rem';}
                if (index < 15) {return '0.18rem';}
                if (index < 20) {return '0.16rem';}
                }
                return '0.16rem';
            };

        let arr =  data.slice(0).map((item) => {
            return {
                count: item['评论提及次数'] || 0,
                url: 'javascript:void(0)',
                label: item['标签'] || '标签缺失',
            }
        }).sort((a, b) => b.count - a.count).map((item:any, index) => {
            item.fontSize = getFontSize(index);
            return item;
        }).slice(0, 20);

        // 排序出现NaN 会出现顺序问题

        return arr;
    }

    drawWordCloud ({dom, data}) {
        this.svg3DTagCloud = null;
        $(dom).html('');
        let tmpDOM = $(dom).html('<div class="tag-tmp-dom" style="width: 100%; height: 100%;"></div>').find('.tag-tmp-dom');

        let {width, height} = dom.getBoundingClientRect();
        if (width === 0) {
            width = 200;
        }
        if (height === 0) {
            height = width / 2.37; // 一定是浏览器的bug 没有跑了
        }
        let settings = {
            entries: data,
            width: width,
            height: height,
            // radius: '40%',
            // radius: window['_screenType'] === '1080' ? '80%' : '100%',
            radius: '100%',
            radiusMin: 75,
            bgDraw: true,
            bgColor: 'transparent',
            opacityOver: 1.00,
            opacityOut: 0.05,
            opacitySpeed: 10,
            fov: 800,
            speed: 0.3,
            // fontFamily: 'Oswald, Arial, sans-serif',
            fontSize: '15',
            fontColor: window['_screenType'] === '1080' ? '#619EF5' : '#4D9DFE',
            fontWeight: 'normal',//bold
            fontStyle: 'normal',//italic
            fontStretch: 'normal',//wider, narrower, ultra-condensed, extra-condensed, condensed, semi-condensed, semi-expanded, expanded, extra-expanded, ultra-expanded
            fontToUpperCase: true,
            tooltipFontSize: '11',
            tooltipFontColor: '#fff',
            tooltipFontWeight: 'normal',//bold
            tooltipFontStyle: 'normal',//italic
            tooltipFontStretch: 'normal',//wider, narrower, ultra-condensed, extra-condensed, condensed, semi-condensed, semi-expanded, expanded, extra-expanded, ultra-expanded
            tooltipFontToUpperCase: false,
            tooltipTextAnchor: 'left',
            tooltipDiffX: 0,
            tooltipDiffY: 10
        };

        var svg3DTagCloud = new SVG3DTagCloud( tmpDOM[0], settings );
        this.svg3DTagCloud = svg3DTagCloud;
        // $(tmpDOM).svg3DTagCloud( settings );
    }

    mounted () {
        if (this.poiData.RightData) {
            this.draw();
        }
        this.$autoOn('window-resize', () => {
            // console.log('word-cloud resize');
            this.svg3DTagCloud && this.svg3DTagCloud.destroy();
            this.draw();
        });
    }
}
